<template lang="pug">
  v-card
    v-card-title
      h2.modal-title {{ 'schedule.add_load' | translate }}
    v-card-content
      v-input-r(
        :label="$t('base.name')"
        :hint="errorMessage('name')"
        :invalid="!!errorMessage('name')"
        v-model="form.name")
      .cols__1
        .cols__1
          v-select(
            :label="$t('base.period')"
            :options="periods"
            v-model="form.period")
      .cols__1
        .cols__1
          v-select(
            :label="$t('base.ration')"
            :options="rationsList"
            v-model="form.ration")
      .cols__1
        .cols__1
          v-multiselect(
            :label="$t('base.animal_groups')"
            :options="groupsList"
            v-model="form.groups")
      .cols__1
        .cols__1
          v-select(
            :label="$t('base.mixer')"
            :options="mixers"
            v-model="form.mixer")
      v-input-r.mb-5(
        :label="$t('base.mix_time')"
        v-model="form.mix_time")
      v-switch.mb-5(
        :label="$t('base.auto_load')"
        v-model="form.auto_load")
      v-switch.mb-2(
        :label="$t('base.activate_planning')"
        v-model="form.is_active")
    v-card-actions
      v-btn(
        :disabled="!isFormFilled"
        :loading="loading"
        @click="onCreate") {{ 'base.add' | translate }}
</template>

<script>
import api from '@/api'
import { mapActions, mapGetters } from 'vuex'
import formErrorsMixin from '@/mixins/form-errors.mixin.js'

import CreateLoadingModal from './CreateLoadingModal'

export default {
  name: 'CreatePlanningModal',

  components: {
    CreateLoadingModal
  },

  data: () => ({
    modals: {
      showCreateLoading: false
    },
    form: {
      name: '',
      auto_load: false,
      is_active: true,
      mix_time: 15,
      period: null,
      mixer: null,
      ration: null,
      groups: []
    },
    errors: {
      name: null
    },
    mixers: [],
    periods: [],
    loading: false
  }),

  mounted () {
    this.loadData()
  },

  computed: {
    ...mapGetters('groups', [
      'groupsList'
    ]),

    ...mapGetters('rations', [
      'rationsList'
    ]),

    allowCreateLoading () {
      return this.hasPermission('loading', 'add')
    },

    allowViewLoadings () {
      return this.hasPermission('loading', 'view')
    },

    allowViewRations () {
      return this.hasPermission('ration', 'view')
    },

    allowViewGroups () {
      return this.hasPermission('group', 'view')
    },

    allowViewMixers () {
      return this.hasPermission('mixer', 'view')
    },

    isFormFilled () {
      return !!this.form.name &&
        !!this.form.period &&
        !!this.form.ration &&
        !!this.form.mixer &&
        this.form.groups.length > 0
    }
  },
  mixins: [formErrorsMixin],
  methods: {
    ...mapActions('schedule', [
      'createSchedule'
    ]),

    ...mapActions('mixers', [
      'loadMixers'
    ]),

    ...mapActions('groups', [
      'loadGroupsList'
    ]),

    ...mapActions('rations', [
      'loadRationsList'
    ]),

    async loadData () {
      if (this.allowViewLoadings) {
        this.loadPeriods()
      }
      const params = {
        farm: this.$route.params.farm_id,
        deleted: 'false'
      }
      if (this.allowViewRations) {
        this.loadRationsList(params)
      }
      if (this.allowViewGroups) {
        this.loadGroupsList(params)
      }
      if (this.allowViewMixers) {
        this.mixers = await this.loadMixers(params)
      }
    },

    async loadPeriods () {
      const params = {
        farm: this.$route.params.farm_id,
        deleted: 'false'
      }
      const { data } = await api.loadings.list(params)
      this.periods = data
    },

    async onCreate () {
      if (this.validateData()) {
        if (this.form.name === '') {
          this.form.name = this.form.ration.name
        }
        const payload = {
          name: this.form.name,
          farm: this.$route.params.farm_id,
          schedule_loading: {
            loading: this.form.period
          },
          schedule_mixer: {
            mixer: this.form.mixer
          },
          schedule_ration: {
            ration: this.form.ration,
            ingredients: []
          },
          schedule_groups: this.form.groups
            .map(item => ({
              group: item.id,
              coefficient: 100,
              ordering: 1
            })),
          coefficient: 100,
          auto_load: this.form.auto_load,
          is_active: this.form.is_active,
          ordering: 1,
          mix_time: Math.floor(+this.form.mix_time * 60)
        }
        this.loading = true
        await this.createSchedule(payload)
        this.$store.dispatch('planning/markPlanningCreated')
        this.loading = false
        this.$emit('update')
        this.$emit('close')
      }
    },

    validateData () {
      this.errors.name = null
      if (!this.form.name) {
        this.errors.name = this.errors.name = ['3']
        return false
      } else if (this.form.name.length > 100) {
        this.errors.name = this.errors.name = ['6', 100]
        return false
      }

      if (!this.form.period) {
        this.$toasted.show(this.$t('Необхідно вибрати період'))
        return false
      }

      if (!this.form.ration) {
        this.$toasted.show(this.$t('info.select_ration'))
        return false
      }

      if (!this.form.mixer) {
        this.$toasted.show(this.$t('info.select_mixer'))
        return false
      }

      if (!this.form.groups.length) {
        this.$toasted.show(this.$t('info.select_animal_group'))
        return false
      }
      return true
    }
  }
}
</script>
<style scoped>
.v-card__title {
  padding: 2rem 2.4rem 1.6rem;
}

.modal-title {
  font-size: 2rem;
  font-weight: 700;
  margin: 0;
}

.v-card__content {
  border-top: .1rem solid #d7d7d7;
  padding-bottom: 1.5rem !important;
}

.v-card__actions {
  padding: 0 2.4rem 2.4rem;
}

.v-card__actions button {
  width: 100%;
}
</style>
